import { createContext, useContext } from "react";
import type { UserMe } from "../types/user";

export interface AuthContextValue {
  user: UserMe | null;
  loading: boolean;
  refresh: () => Promise<void>;
  setUser: (u: UserMe | null) => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useCurrentUser(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useCurrentUser must be used inside <AuthProvider>");
  }
  return ctx;
}
